import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Preference } from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Step2 } from '../../../../shared/models/component-messages/mapaAN/step2';
import { PreferenceType } from '../../../../shared/models/enum/preferenceType';
import { TypeCPVClass } from '../models/TypeCPVClass';
@Component({
  selector: 'app-typeCPV-class',
  templateUrl: './typeCPV-class.component.html'
})
export class TypeCPVClassComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeCPVClass'
  @Input() parentForm: FormGroup;
  @Input() objetPrincipal: TypeCPVClass;
  @Input() disabled: boolean;
  @Input() displayStar: boolean;

  @Output() preferenceSelected = new EventEmitter<Preference>();

  public typeCpv = PreferenceType.CODES_CPV;

  constructor() { }

  public ngOnInit() {
    if (this.objetPrincipal.classSupplementaire === null) {
      this.objetPrincipal.classSupplementaire = [];
    }
  }

  public step2 = new Step2();


  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  chargeDonneePreference(preference: Preference) {
    this.preferenceSelected.emit(preference);
  }
}

